import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { pageStyles } from "../../../theme";

export const useStyles = makeStyles((theme: Theme) => ({
  ...pageStyles(theme),
  root: {},
  divider: {
    width: "15rem",
    borderTop: "1px solid #fff",
    margin: "2rem 0",
  },
  text: {
    maxWidth: theme.spacing(90),
    fontSize: 20,
    lineHeight: 1.2,
  },
  main: {
    padding: "6rem 6rem 0",
    backgroundColor: "#2b2b2b",
  },
  mainHeading: {
    fontSize: 50,
    lineHeight: 1.2,
    fontWeight: 600,
  },
  mainText: {
    fontSize: 25,
    lineHeight: 1.2,
  },
  sectionContainer: {
    padding: "2rem 0",
  },
  imgContainer: {
    padding: "3rem 0",
    textAlign: "center",

    "& img": {
      margin: "0 auto",
    },
  },
  bottomSectionInner: {
    padding: "1.5rem 2rem",
    marginTop: "6rem",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  },
  bottomSectionText: {
    marginTop: "1rem",
    fontSize: 18,
    lineHeight: 1.2,
  },
  bottomSectionLink: {
    marginTop: "3rem",
    fontSize: 16,
    lineHeight: 1.2,
    fontWeight: 600,
    color: "#fff",
  },
}));
